import {
	READ_SETUP,
	UPDATE_SETUP_BIZ,
	UPDATE_SETUP_TECH,
	UPDATE_SETUP,
	UPDATE_EMAIL_SETUP
} from '../config/actionTypes';

const initialState = {
	id: 0,
	biz: {
		// GENERAL
		EXCHANGE_NAME: '',
		DEFAULT_COUNTRY: '',
		TIME_ZONE: 'UTC',
		LANGUAGE: 'en',
		COMPANY_NAME: '',
		OPERATOR_NAME:'',
		SUMMARY:'',
		// BRANDING
		DEFAULT_COLOR: 'white',
		LOGO_IMAGE_LIGHT:
			'https://bitholla.s3.ap-northeast-2.amazonaws.com/kit/LOGO_IMAGE_LIGHT',
		LOGO_IMAGE_LIGHT_ALT:
			'https://bitholla.s3.ap-northeast-2.amazonaws.com/kit/LOGO_IMAGE_LIGHT',
		LOGO_IMAGE_DARK:
			'https://bitholla.s3.ap-northeast-2.amazonaws.com/kit/LOGO_IMAGE_DARK',
		LOGO_IMAGE_DARK_ALT:
			'https://bitholla.s3.ap-northeast-2.amazonaws.com/kit/LOGO_IMAGE_DARK',
		ACCOUNT_TIERS: 4,
		INTERFACE: 'full',
		// ASSETS
		// ASSETS: [
		// 	ASSET_PROPERTIES.btc,
		// 	ASSET_PROPERTIES.xrp,
		// 	ASSET_PROPERTIES.xht,
		// 	ASSET_PROPERTIES.eth,
		// 	ASSET_PROPERTIES.bch,
		// 	ASSET_PROPERTIES.usdt
		// ],
		// PAIRS
		// PAIRS: [
		// 	{
		// 		IS_DEFAULT: true,
		// 		BASE_ASSET: 'btc',
		// 		PRICED_ASSET: 'usdt',
		// 		USE_BASES_POINT: false,
		// 		TAKER_FEE: {},
		// 		MAKER_FEE: {},
		// 		MINIMUM_TRADABLE_AMOUNT: 0.0001,
		// 		MAXIMUM_TRADABLE_AMOUNT: 20000000,
		// 		MINIMUM_TRADABLE_PRICE: 0.0001,
		// 		MAXIMUM_TRADABLE_PRICE: 100000000,
		// 		INCREMENT_AMOUNT: 0.001,
		// 		INCREMENT_PRICE: 0.0001,
		// 		PAIR_ACTIVATE: true
		// 	},
		// 	{
		// 		IS_DEFAULT: true,
		// 		BASE_ASSET: 'xrp',
		// 		PRICED_ASSET: 'usdt',
		// 		USE_BASES_POINT: false,
		// 		TAKER_FEE: {},
		// 		MAKER_FEE: {},
		// 		MINIMUM_TRADABLE_AMOUNT: 0.0001,
		// 		MAXIMUM_TRADABLE_AMOUNT: 20000000,
		// 		MINIMUM_TRADABLE_PRICE: 0.0001,
		// 		MAXIMUM_TRADABLE_PRICE: 100000000,
		// 		INCREMENT_AMOUNT: 0.001,
		// 		INCREMENT_PRICE: 0.0001,
		// 		PAIR_ACTIVATE: true
		// 	},
		// 	{
		// 		IS_DEFAULT: true,
		// 		BASE_ASSET: 'xht',
		// 		PRICED_ASSET: 'usdt',
		// 		USE_BASES_POINT: false,
		// 		TAKER_FEE: {},
		// 		MAKER_FEE: {},
		// 		MINIMUM_TRADABLE_AMOUNT: 0.0001,
		// 		MAXIMUM_TRADABLE_AMOUNT: 20000000,
		// 		MINIMUM_TRADABLE_PRICE: 0.0001,
		// 		MAXIMUM_TRADABLE_PRICE: 100000000,
		// 		INCREMENT_AMOUNT: 0.001,
		// 		INCREMENT_PRICE: 0.0001,
		// 		PAIR_ACTIVATE: true
		// 	},
		// 	{
		// 		IS_DEFAULT: true,
		// 		BASE_ASSET: 'eth',
		// 		PRICED_ASSET: 'usdt',
		// 		USE_BASES_POINT: false,
		// 		TAKER_FEE: {},
		// 		MAKER_FEE: {},
		// 		MINIMUM_TRADABLE_AMOUNT: 0.0001,
		// 		MAXIMUM_TRADABLE_AMOUNT: 20000000,
		// 		MINIMUM_TRADABLE_PRICE: 0.0001,
		// 		MAXIMUM_TRADABLE_PRICE: 100000000,
		// 		INCREMENT_AMOUNT: 0.001,
		// 		INCREMENT_PRICE: 0.0001,
		// 		PAIR_ACTIVATE: true
		// 	},
		// 	{
		// 		IS_DEFAULT: true,
		// 		BASE_ASSET: 'bch',
		// 		PRICED_ASSET: 'usdt',
		// 		USE_BASES_POINT: false,
		// 		TAKER_FEE: {},
		// 		MAKER_FEE: {},
		// 		MINIMUM_TRADABLE_AMOUNT: 0.0001,
		// 		MAXIMUM_TRADABLE_AMOUNT: 20000000,
		// 		MINIMUM_TRADABLE_PRICE: 0.0001,
		// 		MAXIMUM_TRADABLE_PRICE: 100000000,
		// 		INCREMENT_AMOUNT: 0.001,
		// 		INCREMENT_PRICE: 0.0001,
		// 		PAIR_ACTIVATE: true
		// 	}
		// ],
		// HOSTING
		TECH_EMAIL: '',
	},
	EMAIL_SETUP: {},
	tech: { SERVER_TYPE: '' }
};

const StatReducer = (state = initialState, action) => {
	const newState = { ...state };
	const { data } = action;
	switch (action.type) {
		case READ_SETUP:
			return initialState;
		case UPDATE_SETUP:
			return { ...newState, ...data };
		case UPDATE_SETUP_BIZ:
			newState.biz = { ...newState.biz, ...data };
			return newState;
		case UPDATE_SETUP_TECH:
			newState.tech = { ...newState.tech, ...data };
			return newState;
		case UPDATE_EMAIL_SETUP:
			newState.EMAIL_SETUP = { ...newState.EMAIL_SETUP, ...data.EMAIL_SETUP };
			return newState;
		default:
			return state;
	}
};

export default StatReducer;
